
/**
  * PNP-Aufgabe: Zuordnung von Elementen zu Körben
  * @namespace v3sWbtPlayerApp:exercise:pnp
  */
/**
 * Ermöglicht die Darstellung von Target-Elementen einer Pick And Place Aufgabe
 * @class directive_v3sTarget
 * @memberOf v3sWbtPlayerApp:exercise:pnp
 */

angular.module('v3sWbtPlayerApp').directive('v3sTarget', ['v3sTargetElement', 'v3sContentMediaPath', function (v3sTargetElement, v3sContentMediaPath) {
    return {
        restrict: 'E',
        require: ['^v3sExercise','^v3sDocument'],
        transclude: true,
        link: function (scope, element, attrs, controllers, transclude) {
            var sourceLimit = 1;
            var exCtrl = controllers[0];
            var docCtrl = controllers[1];

            docCtrl.addElement(element);
            
            transclude(scope, function (clone, scope) {
                angular.forEach(clone, function (node) {
                    var tagName = node.tagName.toLowerCase();
                    var innerText = node.textContent;
                    if (tagName == 'v3s-sources') {
                        //Gibt es ein limit
                        if (node.attributes['v3s-limit'].value != "") {
                            sourceLimit = parseInt(node.attributes['v3s-limit'].value);
                        } else {
                            sourceLimit = parseInt(innerText);
                        }
                    } else if (tagName == 'v3s-source-item') {
                        console.log(innerText);
                    }
                })
            })
            //TODO: Soll v3sTargetElement im Konstruktur werte wie Breite etc aus 
            // dem Element ziehen, oder soll das in der Konstrukturfunktion angegeben werden?


            var targetElement = new v3sTargetElement(element, sourceLimit);
            exCtrl.addTarget(targetElement);
            if (!!attrs.v3sFile) {
                element.css({
                    'background-image': 'url(./' + v3sContentMediaPath + attrs.v3sFile + ')'
                })
            }
            
        }
    }
}]);


/**
 * Das Model des Targetelements der Pick and Place Aufgaben
 * @class service_v3sTargtElement
 * @memberOf v3sWbtPlayerApp:exercise:pnp
 */
angular.module('v3sWbtPlayerApp').factory('v3sTargetElement', function () {
    /**
     * Konstruktor, registriert das Element beim {@link v3sWbtPlayerApp:exercise.service_v3sExerciseService} zur Auswertung
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sTargetElement
     * @constructor
     */
    var v3sTargetElement = function (element, sourceLimit) {
        this.id = element.attr('id');
        this.element = element;
        this.width = parseInt(this.element.css('width'));
        this.height = parseInt(this.element.css('height'));
        this.limit = sourceLimit;
        this.sources = [];
    }

    /**
     * Returns the angular.element of the targetElement
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sTargetElement
     */
    v3sTargetElement.prototype.getElement = function () {
        return this.element;
    }

    /**
     * Errechnet, ob noch logischer Platz in dem Target ist
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sTargetElement
     */
    v3sTargetElement.prototype.hasLogicalSpace = function () {
        var hasLogicalSpace = (this.limit > this.sources.length) ? true : false;
        return hasLogicalSpace;

    }

    /**
     * Errechnet, ob noch phyischer Platz in dem Target ist
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sTargetElement
     */
    //TODO einmal neu bitte
    v3sTargetElement.prototype.hasPhysicalSpace = function(newSource){
        var self = this;
        var newSourceBorder = parseInt(newSource.attr('v3s-border')) * 2 || 0;
        var neededHeight = newSource[0].offsetHeight + newSourceBorder;
        var neededWidth = newSource[0].offsetWidth + newSourceBorder;
        var remainingTargetHeight = self.height;
        var remainingTargetWidth = self.width;
        var innerSourceWidth, innerSourceHeight, innerSourceBorder;
        //Für jede zugeordnete Source wird geprüft, ob sie horizontal bzw. vertikal platz
        //Dann wird der jeweilige wert verringert.
        //Am Ende wird getestet, ob die neue Source reinpassen würde
        angular.forEach(self.sources, function (s,index) {
            innerSourceBorder = parseInt(s.element.attr('v3s-border'))*2 || 0;
            innerSourceHeight = s.element[0].offsetHeight + innerSourceBorder;
            innerSourceWidth = s.element[0].offsetWidth + innerSourceBorder;

            //Der erste verringert immer die Höhe
            if (index == 0) {
                remainingTargetHeight -= innerSourceHeight;
            }


            if (innerSourceWidth <= remainingTargetWidth) {//Es passt vertikal rein
                remainingTargetWidth -= innerSourceWidth;
            } else if(innerSourceHeight <= remainingTargetHeight) {
                remainingTargetHeight -= innerSourceHeight;
                //Neue Zeile -> Breite wieder zurücksetzen
                remainingTargetWidth = self.width - innerSourceWidth;
            }
        });

        if (remainingTargetHeight >= neededHeight || remainingTargetWidth >= neededWidth ) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Fügt dem Sources-Array ein weiteres Element hinzu
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sTargetElement
     * @param {object} s - das sourceElement
     */
    v3sTargetElement.prototype.addSource = function (s) {
        this.sources.push(s);
    }

    v3sTargetElement.prototype.appendElement = function (el) {
        this.element.append(el); 
    }

    /**
     * Findet ein Source-Element in dem Target
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sTargetElement
     * @param {object} s - das SourceElement
     */
    v3sTargetElement.prototype.findSource = function (s) {
        var i = this.sources.indexOf(s);
        var foundSource = null;
        if (i !== -1) {
            foundSource = this.sources[i];
        }
        return foundSource;
    }
    
    /**
     * Gibt zurück, wieviele korrekt zugeordnete SourceElement in dem Target sind
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sTargetElement
     */
    v3sTargetElement.prototype.getCorrectSourcesCount = function () {
        var self = this;
        var correctSourcesCount = 0;
        angular.forEach(self.sources, function (s) {
            if (s.status == s.STATUS.CORRECT) {
                correctSourcesCount++;
            }
        })
        return correctSourcesCount
    }

    v3sTargetElement.prototype.hasAllCorrect = function () {
        var self = this;
        return (self.getCorrectSourcesCount() === self.getLimit());
    }

    /**
     * Getter für this.limt
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sTargetElement
     */
    v3sTargetElement.prototype.getLimit = function () {
        return this.limit;
    }
    
    /**
     * Löscht ein sourceElement aus dem sources-array
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sTargetElement
     * @param {object} s - das SourceElement
     */
    v3sTargetElement.prototype.removeSource = function (s) {
        var i = this.sources.indexOf(s);
        if (i !== -1) {
            this.sources.splice(i, 1);
        }
        
    }

    /**
     * Prüft ob bereits Kopien des SourceElements in dem Target vorhanden sind
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sTargetElement
     * @param {object} se - sourceElement
     */
    v3sTargetElement.prototype.containsCopies = function (se) {
        var self = this;
        var containsCopies = false;
        angular.forEach(self.sources, function (s) {
            if (s.sourceId == se.sourceId && s.id != se.id) {
                containsCopies = true;
            }
        });
        return containsCopies;
    }
    return v3sTargetElement;
});
